<template>
  <div :class="style.container">
    <label v-for="time in timeList" :key="time">
      <input
        v-if="multiple"
        v-model="checkedTimes"
        hidden
        type="checkbox"
        :value="time"
        @change="updateInput(checkedTimes)"
      />
      <input
        v-else
        hidden
        type="radio"
        :value="time"
        :checked="time === value"
        @change="updateInput($event.target.value)"
      />
      <span :class="style.select">{{ time }}</span>
    </label>
    <span
      v-if="multiple"
      :class="[style.select, { [style.active]: selectedAll }]"
      @click="selectAll"
      >{{ availableTime }}</span
    >
  </div>
</template>

<script>
import createTimeList, { inTimeRange } from 'Utilities/TimerHelper'
import style from './scss/_time_selector.scss'

export default {
  props: {
    timeLimited: { type: Array, required: true },
    selectedDate: { type: String, required: true },
    multiple: { type: Boolean, default: false },
    selectedMeal: { type: String },
    value: { type: [String, Array] },
    inTimeRange: { type: Function }
  },
  data() {
    return {
      checkedTimes: this.value,
      selectedAll: false
    }
  },
  computed: {
    style: () => style,
    timeList() {
      return inTimeRange(this.timeLimited, this.selectedDate, this.genTimeList)
    },
    availableTime() {
      return this.$t('restaurant_form.any_available_time')
    }
  },
  watch: {
    value() {
      this.checkedTimes = this.value
    }
  },
  methods: {
    updateInput(value) {
      this.$emit('input', value)
    },
    selectAll() {
      this.selectedAll = !this.selectedAll
      if (this.selectedAll) {
        this.checkedTimes = this.timeList
      } else {
        this.checkedTimes = []
      }
      this.$emit('input', this.checkedTimes)
    },
    genTimeList(timeRange) {
      if (!this.selectedMeal) {
        return []
      }
      if (timeRange[this.selectedMeal].time_list) {
        return timeRange[this.selectedMeal].time_list
      }
      const rangeOption = {
        startTime: timeRange[this.selectedMeal].start_time,
        endTime: timeRange[this.selectedMeal].end_time
      }
      return createTimeList(1, timeRange[this.selectedMeal].minute_increment, rangeOption, false)
    }
  }
}
</script>
